import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth";

import "../App.scss";
import Button from "./Button";

export default function Navbar() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="header"
      style={isMobile ? { flexDirection: "column" } : null}
    >
      <div>
        <Button
          style={isMobile ? { width: "100%" } : null}
          onClick={() => navigate("/")}
        >
          Home
        </Button>
        <Button
          style={isMobile ? { width: "100%" } : null}
          onClick={() => navigate("/about")}
        >
          About KYEWB
        </Button>
        <Button
          style={isMobile ? { width: "100%" } : null}
          onClick={() => navigate("/guestbook")}
        >
          Guestbook
        </Button>
      </div>

      {currentUser && !isMobile && (
        <div className="dropdown">
          <button className="dropbtn">
            {currentUser?.data?.displayName || currentUser?.data?.email}
          </button>
          <div className="dropdown-content">
            <Button className="dropdown-button" onClick={logout}>
              Logout
            </Button>
          </div>
        </div>
      )}
      {currentUser && isMobile && (
        <Button className="dropdown-button" onClick={logout}>
          Logout
        </Button>
      )}
    </div>
  );
}
